<template>
    <div class="link">
        <div style='width: 100%;text-align: center;margin: 75px 0 ;'>
            <img src='../../assets/images/no_page.png' alt='' width="160">
        </div>
    </div>
</template>

<script>
export default {
  name: "link",
  created() {
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[5]");
  }
};
</script>

<style scoped lang="less">
.link {
  @media (min-width: 410px) {
    min-height: 527px;
  }
  @media (max-width: 375px) {
    min-height: 463px;
  }
  @media (max-width: 360px) {
    min-height: 426px;
  }
  @media (max-width: 320px) {
    min-height: 348px;
  }
}
</style>
